import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import apiClient from "../../AppClient";

function ProductScreen() {
  const { id } = useParams();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [productData, setProductData] = useState({
    name: "",
    fertilization_schedule: "",
    schedule_type: "",
    quantity_available: "",
    sale_price: "",
    details: "",
    classification: "",
  });

  useEffect(() => {
    fetchProduct();
  }, []);

  const fetchProduct = async () => {
    setLoading(true);
    apiClient
      .get(`/products/${id}/`)
      .then((response) => {
        setProductData(response.data);
        setError(null);
        setLoading(false);
      })
      .catch((error) => {
        if (error.response) {
          setError(error.response.data.detail);
          setLoading(false);
        } else {
          setError("حدث خطأ اثناء الاتصال بالسيرفر");
          setLoading(false);
        }
      });
  };

  return (
    <div className="container mt-4">
      <h2 className="text-center mb-4">تفاصيل المنتج</h2>
      {error && (
        <div className="alert alert-danger">
          {error}
        </div>
      )}
      {loading ? (
        <div className="text-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">جاري التحميل...</span>
          </div>
        </div>
      ) : (
        <div className="card shadow">
          <div className="card-header bg-dark text-white">
            <h4 className="mb-0 text-white">{productData.name || "اسم المنتج غير متوفر"}</h4>
          </div>
          <div className="card-body">
            <div className="row mb-3">
              <div className="col-md-6">
                <strong>اسم المنتج:</strong>
                <p className="text-muted">{productData.name || "غير متوفر"}</p>
              </div>
              <div className="col-md-6">
                <strong>الكمية المتاحة:</strong>
                <p className="text-muted">
                  {productData.quantity_available || "غير متوفر"}
                </p>
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-6">
                <strong>السعر:</strong>
                <p className="text-muted">
                  {productData.sale_price
                    ? `${productData.sale_price} جنيه`
                    : "غير متوفر"}
                </p>
              </div>
              <div className="col-md-6">
                <strong>جدول التسميد:</strong>
                <p className="text-muted">
                  {productData.fertilization_schedule && productData.schedule_type
                    ? `${productData.fertilization_schedule} ${productData.schedule_type}`
                    : "غير متوفر"}
                </p>
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-6">
                <strong>التصنيف:</strong>
                <p className="text-muted">
                  {productData.classification || "غير متوفر"}
                </p>
              </div>
              <div className="col-md-6">
                <strong>الوصف:</strong>
                <p className="text-muted">{productData.details || "غير متوفر"}</p>
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-12 text-center">
                {productData.image ? (
                  <img
                    src={`${process.env.REACT_APP_API_URL}${productData.image}`}
                    alt={productData.name || "صورة المنتج"}
                    className="img-fluid rounded shadow"
                    width={300}
                    height={300}
                  />
                ) : (
                  <p className="text-muted">صورة غير متوفرة</p>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ProductScreen;